var map = {
	"./ar.json": [
		1925,
		[
			925
		]
	],
	"./bn.json": [
		4118,
		[
			118
		]
	],
	"./cy.json": [
		3802,
		[
			802
		]
	],
	"./en.json": [
		8053,
		[]
	],
	"./es.json": [
		1406,
		[
			406
		]
	],
	"./fr.json": [
		7222,
		[
			222
		]
	],
	"./gd.json": [
		405,
		[
			405
		]
	],
	"./gu.json": [
		42,
		[
			42
		]
	],
	"./pa.json": [
		545,
		[
			545
		]
	],
	"./pl.json": [
		6690,
		[
			690
		]
	],
	"./pt.json": [
		5034,
		[
			34
		]
	],
	"./ro.json": [
		5489,
		[
			489
		]
	],
	"./so.json": [
		6820,
		[
			820
		]
	],
	"./tr.json": [
		2584,
		[
			584
		]
	],
	"./ur.json": [
		1785,
		[
			785
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7737;
module.exports = webpackAsyncContext;